import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/repeat_service'
import store from '@/store.js'

export default {
  getSummary () {
    return axios.get(store.state.apiUrl + URL + '/summary' ).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  sendConfirmationEmail (data) {
    let url = store.state.apiUrl + URL + '/confirmation_email/' + data.repeatServiceId + `?outbound_email=${data.outboundEmail}&return_email=${data.returnEmail}`
    if (data.email) {
      url += `&email=${data.email}`
    }
    return axios.get(url).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
}
